import { useRouter } from 'next/router'

import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'

import { getCategoryTitle } from 'app/ProfileRevampPage/utils/perangkatAjar'
import { useBackButton } from 'app/ProfileRevampPage/hooks/useBackButton'

const Header = () => {
  const router = useRouter()
  const { category } = router.query
  const { onClickBack } = useBackButton()

  return (
    <HeaderBar fixed>
      <HeaderBarLeftAction onClick={onClickBack} />
      <HeaderBarTitle className="capitalize">
        {getCategoryTitle(category as string)}
      </HeaderBarTitle>
    </HeaderBar>
  )
}

export default Header
